"use client";

import React, { useState } from 'react';
import IntentModal from '@components/molecules/IntentModal';
import GlobalLoader from '@components/atoms/GlobalLoader/GlobalLoader';
import { useAppSelector } from '@lib/redux/hooks';
import { BuyingIntentData } from '@services/globalIntentService';
import { PageType } from '@constants/pageTypes';
import { inApp } from '@utils/platformDetection.client';

interface GlobalIntentModalProps {
  isOpen: boolean;
  onClose: () => void;
  buyingIntent: BuyingIntentData | null;
  mmvDetails?: any;
  cityName: string;
  pageType?: PageType | null;
  loginType?: string | null;
  disableClose?: boolean;
}

const GlobalIntentModal: React.FC<GlobalIntentModalProps> = ({
  isOpen,
  onClose,
  buyingIntent,
  cityName,
  mmvDetails,
  pageType,
  loginType,
  disableClose = false,
}) => {
  const userProfile = useAppSelector((state) => state.profile.data);
  const [showAppLoader, setShowAppLoader] = useState(false);

  const handleClose = () => {
    setShowAppLoader(false);
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('buying_intent', 'false');
    }
    onClose();
  };

  const handleIntentSelect = () => {
    if (inApp()) {
      setShowAppLoader(true);
    }
  };

  const handleIntentSelectionComplete = () => {
    setShowAppLoader(false);
  };

  if (!buyingIntent || !userProfile) {
    return null;
  }

  return (
    <>
      <IntentModal
        isOpen={isOpen}
        onClose={handleClose}
        buyingIntent={buyingIntent}
        cityName={cityName}
        variant="simple"
        onIntentSelect={handleIntentSelect}
        onIntentSelectionComplete={handleIntentSelectionComplete}
        onGetQuote={handleClose}
        highPriorityCapture={false}
        mmvDetails={mmvDetails}
        pageType={pageType}
        loginType={loginType}
        disableClose={disableClose}
      />
      {showAppLoader && (
        <GlobalLoader
          isLoading
          overlay
          text=""
          size="large"
          variant="spinner"
        />
      )}
    </>
  );
};

export default GlobalIntentModal;
